import React from 'react';
import { googleReviews } from '../data/googleReviews';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const GoogleReviewsCarousel: React.FC = () => {
  return (
    <section className="google-reviews-section" style={{ width: '100%', maxWidth: '1400px', margin: '0 auto', padding: '48px 0' }}>
      <h2 className="section-title-hyper" style={{ marginTop: '2rem', textAlign: 'center' }}>Comentarios</h2>
      <div className="google-reviews-rating" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '2.5rem' }}>
        <span style={{ fontSize: '2.6rem', color: '#10b981', fontWeight: 800, marginRight: '1.2rem' }}>
          {googleReviews.rating} ★
        </span>
        <span style={{ fontSize: '1.3rem', color: '#333', fontWeight: 600 }}>
          {googleReviews.total} opiniones en Google
        </span>
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={32}
        slidesPerView={1}
        style={{ width: '100%', maxWidth: '900px', margin: '0 auto', marginBottom: '2rem' }}
      >
        {googleReviews.reviews.map((review, idx) => (
          <SwiperSlide key={idx}>
            <div className="google-review-card" style={{
              background: '#fff',
              borderRadius: '24px',
              boxShadow: '0 8px 32px rgba(16,185,129,0.12)',
              padding: '2.5rem 2rem',
              margin: '0 auto',
              maxWidth: '700px',
              minHeight: '180px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <div className="google-review-stars" style={{ marginBottom: '1.2rem', display: 'flex', gap: '0.2rem', justifyContent: 'center' }}>
                {Array.from({ length: review.stars }).map((_, i) => (
                  <span key={i} style={{ color: '#10b981', fontSize: '2rem', fontWeight: 700 }}>★</span>
                ))}
              </div>
              <p className="google-review-text" style={{ fontSize: '1.25rem', color: '#222', textAlign: 'center', marginBottom: '1.2rem', fontWeight: 500 }}>
                {review.text}
              </p>
              <div className="google-review-user" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.7rem', fontSize: '1.05rem', color: '#555' }}>
                <strong style={{ color: '#052c4d', fontWeight: 700 }}>{review.user}</strong>
                <span style={{ color: '#888', fontSize: '0.98rem' }}>{review.date}</span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default GoogleReviewsCarousel;
